// src/admin/AdminViewFamily.js
import React from "react";
import { useParams, useLocation, Navigate } from "react-router-dom";
import FamilyDashboard from "../pages/FamilyDashboard";
import { auth } from "../firebase";

export const AdminViewFamily = () => {
  const { uid } = useParams();
  const location = useLocation();
  const state = location.state || {};
  const { adminView } = state;

  const currentUser = auth.currentUser;
  if (!currentUser) {
    return <Navigate to="/admin-login" replace />;
  }

  return (
    <FamilyDashboard
      overrideUid={uid}
      adminView={!!adminView}
    />
  );
};

export default AdminViewFamily;
